import { cached } from '@porotutu/react'
import {
  historyDeps,
  historyOffsetOf,
  historyWindow,
} from '@porotutu/react/components/History/History'
import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { permittedRoute, signedInRoute, writesRoute } from '@/router/root'
import { organizationHistoryQuery, organizationQuery } from './queries'

export const organizationRoute = createRoute({
  getParentRoute: () => signedInRoute,
  beforeLoad: permittedRoute('organizations'),
  path: '/organization',
  loader: ({ context }) => context.queryClient.query(cached(organizationQuery)),
  component: lazyRouteComponent(() => import('./pages'), 'OrganizationPage'),
})

export const editOrganizationRoute = createRoute({
  getParentRoute: () => signedInRoute,
  beforeLoad: writesRoute('organizations'),
  path: '/organization/edit',
  loader: ({ context }) => context.queryClient.query(cached(organizationQuery)),
  component: lazyRouteComponent(() => import('./pages'), 'EditOrganizationPage'),
})

const historySearch = (raw: Record<string, unknown>) => {
  const history_offset = historyOffsetOf(raw)

  return history_offset === undefined ? {} : { history_offset }
}

export const organizationHistoryRoute = createRoute({
  getParentRoute: () => signedInRoute,
  beforeLoad: permittedRoute('organizations'),
  path: '/organization/history',
  validateSearch: historySearch,
  loaderDeps: historyDeps,
  loader: ({ context, deps }) =>
    Promise.all([
      context.queryClient.query(cached(organizationQuery)),
      context.queryClient.query(
        cached(organizationHistoryQuery(historyWindow(deps.history_offset))),
      ),
    ]),
  component: lazyRouteComponent(() => import('./pages'), 'OrganizationHistoryPage'),
})

export const organizationRoutes = [
  organizationRoute,
  editOrganizationRoute,
  organizationHistoryRoute,
]
